export default "__VITE_ASSET__OeVOftv6__"